type props = {
	dataTestId?: string;
};

export default function AuthOr({ dataTestId }: props) {
	return (
		<div className="flex items-center mt-4 w-full" data-testid={dataTestId}>
			<div className="flex-1 border-t-2 border-gray-400"></div>
			<span className="px-3 bg-white text-gray-600">or</span>
			<div className="flex-1 border-t-2 border-gray-400"></div>
		</div>
	);
}
